import { postJwtRefreshToken } from '@framework/api-client/api/auth/jwt-controller/jwt-controller.ts';
import { type RefreshTokenCallback } from './RefreshTokenCallback.ts';

/**
 * Metodo di refresh del token tramite JWT.
 */
export const refreshJwtToken: RefreshTokenCallback = async (
  store,
  authState,
) => {
  const { roleId, officeId } = authState;
  return postJwtRefreshToken(
    {
      idRuolo: roleId ?? undefined,
      idUfficio: officeId ?? undefined,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${store.getState().auth.refreshToken ?? ''}`,
        'x-web-refresh': true,
      },
    },
  ).then(res => {
    return {
      accessToken: res.accessToken!,
      refreshToken: res.refreshToken,
    };
  });
};
